<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <MisBuzones></MisBuzones>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import MisBuzones from '../components/MisBuzones.vue';
export default {
    name: 'HomeView',
    components: {
        ColumnaIzquierda,
        MisBuzones,
    }
}
</script>